import { render, staticRenderFns } from "./StudyQuizQuestionBloodGlucose.vue?vue&type=template&id=253de044"
import script from "./StudyQuizQuestionBloodGlucose.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionBloodGlucose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports